export default __webpack_public_path__ + "static/media/DZ.569e568f.svg";